/* app/ui/form/form.umbraco */

define(
	'app/ui/form/form.umbraco',[
		'jquery'
	],
	function($) {

		'use strict';

		return {
			init: function() {
				var $umbracoForms = $('.js-umbraco-form');

				if ($umbracoForms.length) {
					require(
						[
							'moment',
							'pikaday',
							'validate',
							'validateUnobtrusive'
						],
						function (moment, Pikaday) {
							require(
								[
									'../../../../App_Plugins/UmbracoForms/Assets/themes/terabyte/umbracoforms',
									'../../../../App_Plugins/UmbracoForms/Assets/umbracoforms-conditions',
									'../../../../App_Plugins/UmbracoForms/Assets/umbracoforms-dependencies'
								],
								function () {

									var $datepickers = $umbracoForms.find('.datepickerfield');
									if ($datepickers.length) {
										$datepickers.each(function () {
											var $datepicker = $(this);

											if ($('.touchevents').length) {
												$datepicker.attr('readonly', 'readonly');
											}
											new Pikaday({
												field: this,
												yearRange: 10,
												onSelect: function(date) {
													setShadow($datepicker[0].id.replace("_1", ""), date);
												}
											});
										});
									}

									function setShadow(id, date) {
										var value = moment(date).format('YYYY-MM-DD');
										var field = document.getElementById(id);
										field.value = value;
									}
									
								});
						}
					);
				}
			}
		};
	}
);
